import * as React from 'react';
import { Table, SortableTableHeader } from "soprasteria-ui-library";
import { IInvoice } from '../../../../models/IInvoice';
import { dateTimeToDateString } from '../../../../helpers/DateHelper';
import { INVOICE } from '../../../../utils/RouteConstants';
import { Link } from 'react-router-dom';
import { formatCurrency } from '../../../../helpers/CurrencyHelper';

interface ISearchInvoiceTable {
    invoices: IInvoice[];
}

export const SearchInvoiceTable: React.FunctionComponent<ISearchInvoiceTable> = ({ invoices }) => {

    const renderTableLink = (linkText?: string, invoiceId?: number) => {
        return <Link  to={`${INVOICE}/${invoiceId}`}>{linkText}</Link>
    }

    return (
        <Table hoverableRows>
            <thead>
                <tr>
                    <SortableTableHeader propertyToSortBy="InvoiceDate" headerText="Fakturadatum" />
                    <th>Förfallodatum</th>
                    <th>Extern fakturareferens</th>
                    <th>Verifikationsnummer</th>
                    <th>Vårdgivare</th>
                    <th>Mottagning</th>
                    <th>Typ</th>
                    <th>Fakturastatus</th>
                    <th className="text-right">Summa</th>
                </tr>
            </thead>
            <tbody>
                {
                    invoices.length > 0 ?
                        invoices.map((invoice, key) =>
                            <tr key={key} className="clickable-row">
                                <td className="table-data-link">{renderTableLink(dateTimeToDateString(invoice.invoiceDate), invoice.invoiceId)}</td>
                                <td className="table-data-link">{renderTableLink(dateTimeToDateString(invoice.invoiceDueDate), invoice.invoiceId)}</td>
                                <td className="table-data-link">{renderTableLink(invoice.invoiceReference, invoice.invoiceId)}</td>
                                <td className="table-data-link">{renderTableLink(invoice.invoiceVerNr, invoice.invoiceId)}</td>
                                <td className="table-data-link">{renderTableLink(invoice.careProvider.displayOrganisationInformation, invoice.invoiceId)}</td>
                                <td className="table-data-link">{renderTableLink(invoice.careProvider.displayCareProviderName, invoice.invoiceId)}</td>
                                <td className="table-data-link">{renderTableLink(invoice.invoiceType, invoice.invoiceId)}</td>
                                <td className="table-data-link">{renderTableLink(invoice.status, invoice.invoiceId)}</td>
                                <td className="text-right text-nowrap table-data-link">{renderTableLink(formatCurrency(invoice.amount), invoice.invoiceId)}</td>
                            </tr>
                        )
                        : <tr><td colSpan={8}>Inga fakturor hittades</td></tr>
                }
            </tbody>
        </Table>
    )
}

